__turbopack_context__.v({
  "container": "PillTab-module-scss-module__2Vqvnq__container",
  "root": "PillTab-module-scss-module__2Vqvnq__root",
  "selected": "PillTab-module-scss-module__2Vqvnq__selected",
});
